import { Loader } from "./Loader";

export class Source {

    public type: string;
    public count: number;
    public stride: number;
    public params: string[];
    public floats: Float32Array;
    public strings: string[];

    public loadBlob(dataView: DataView, loader: Loader) {
        let offset = 0;

        let typeResult = loader.util.readString(dataView, offset);
        let type = typeResult.string;
        offset = typeResult.offset;

        this.type = type;

        let stringsResult = loader.util.readStrings(dataView, offset);
        this.params = stringsResult.strings;
        offset = stringsResult.offset;

        this.count = dataView.getInt32(offset, true);
        offset += 4;

        this.stride = dataView.getInt32(offset, true);
        offset += 4;

        switch (type) {
            case 'float':
                var length = dataView.getInt32(offset, true);
                offset += 4;

                var alignedBuffer = dataView.buffer.slice(dataView.byteOffset + offset, dataView.byteOffset + offset + length * 4);
                this.floats = new Float32Array(alignedBuffer);
                offset += length * 4;
                break;
            case 'string':
                let strs = loader.util.readStrings(dataView, offset);
                this.strings = strs.strings;
                offset = strs.offset;
                break;
        }

    }
}
